import { ApiCurrentUser, UserPerm } from '../../types/api'

export interface State {
  isLoggedIn: boolean
  user: ApiCurrentUser
}

const thisState: State = {
  isLoggedIn: false,
  user: {
    account: '',
    wsid: ''
  },
}

const mutations = {
  assignLoginState (state: State, user: ApiCurrentUser | null) {
    if (user) {
      state.isLoggedIn = true
      state.user = user
    } else {
      state.isLoggedIn = false
      state.user.account = ''
      state.user.wsid = ''
    }
  }
}

const actions = {
}

export default {
  namespaced: true,
  state: thisState,
  mutations,
  actions
}
